import React from "react";
import { Navigate, useRoutes } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import MainLayout from "../layouts/MainLayout";
import StaffPage from "../pages/staff/StaffPage";
import CreateStaffPage from "../pages/staff/CreateStaffPage";
import DetailStaffPage from "../pages/staff/DetailStaffPage";
import MembershipPage from "../pages/membership/MembershipPage";
import CreateMembershipPage from "../pages/membership/CreateMembershipPage";
import DetailMembershipPage from "../pages/membership/DetailMembershipPage";
import LoanDetailMembershipPage from "../pages/membership/LoanDetailMembershipPage";
import UpdateMembershipPage from "../pages/membership/UpdateMembershipPage";
import UpdateStaffPage from "../pages/staff/UpdateStaffPage";
import LoanPage from "../pages/loan/LoanPage";
import DetailLoanPage from "../pages/loan/DetailLoanPage";
import DepositAndWithdrawPage from "../pages/deposit_and_withdraw/DepositAndWithdrawPage";
import PrivateRoute from "./PrivateRoute";
import DashboardPage from "../pages/dashboard/DashboardPage";
import FormLoan from "../pages/loan/FormLoan";
import CustomerPayment from "../pages/payment-management/CustomerPayment";
import Nofound from "../pages/Nofound";
import ReportPage from "../pages/dashboard/ReportPage";



function Routes() {
  return useRoutes([
    {
      path: "/login",
      element: <LoginPage />,
      errorElement: <div>err</div>,
    },
    {
      path: "/member-payment/:id",
      element: <CustomerPayment />,
    },
    {
      path: "/",
      element: (
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      ),
      children: [
        {
          path: "",
          element: <Navigate to="/dashboard" />,
          errorElement: <div>err</div>,
        },
        {
          path: "/report",
          element: <ReportPage />,
          errorElement: <div>err</div>,
        },
        // -deposit and withdraw-------------------------------------------------deposit and withdraw--------------------------------------------------deposit and withdraw-
        {
          path: "deposit-and-withdraw",
          element: <DepositAndWithdrawPage />,
        },
        // {
        //   path: "loan/create",
        //   element: <CreateStaffPage />,
        // },
        // {
        //   path: "loan/update/:loan",
        //   element: <UpdateStaffPage />,
        // },
        {
          path: "deposit-and-withdraw/detail/:loanId",
          element: <DetailLoanPage />,
        },
        // -loan-------------------------------------------------loan--------------------------------------------------loan-
        {
          path: "loan",
          element: <LoanPage />,
        },
        // {
        //   path: "loan/create",
        //   element: <CreateStaffPage />,
        // },
        // {
        //   path: "loan/update/:loan",
        //   element: <UpdateStaffPage />,
        // },
        {
          path: "loan/detail/:loanId",
          element: <DetailLoanPage />,
        },
        // -staff-------------------------------------------------staff--------------------------------------------------staff-
        {
          path: "staff",
          element: <StaffPage />,
        },
        {
          path: "staff/create",
          element: <CreateStaffPage />,
        },
        {
          path: "staff/update/:staffId",
          element: <UpdateStaffPage />,
        },
        {
          path: "staff/detail/:staffId",
          element: <DetailStaffPage />,
        },
        // -membership-------------------------------------------------membership--------------------------------------------------membership-
        {
          path: "membership",
          element: <MembershipPage />,
        },
        {
          path: "membership/create",
          element: <CreateMembershipPage />,
        },
        {
          path: "membership/update/:membershipId",
          element: <UpdateMembershipPage />,
        },
        {
          path: "membership/detail/:membershipId",
          element: <DetailMembershipPage />,
        },
        {
          path: "membership/detail/:membershipId/loan-detail/:loanId",
          element: <LoanDetailMembershipPage />,
        },
        {
          path: "loan/formload",
          element: <FormLoan />,
        },
        // -dashboard-------------------------------------------------dashboard--------------------------------------------------dashboard-
        {
          path: "dashboard",
          // element: <DashboardPage />,
          element:<ReportPage />
        },
      ],
    },
    {
      path: "*",
      element: <Nofound />,
      errorElement: <div>err</div>,
    },
  ]);
}

export default Routes;
